const convertRemToPx = (remStringValue) => {
  // most of the time 1rem = 16px
  // if the root font-size changed e.g. to 24px then 1rem = 24px
  const valueAsRem = parseFloat(remStringValue);
  const valueAsPx = valueAsRem * 16;
  return valueAsPx;
};

export default convertRemToPx;
